import { Form, Radio, RadioChangeEvent, Row } from "antd";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TenantType } from "../../../../../types/bookings";

type TenantTypeRadioProps = {
  onChange?: (tenantType: TenantType) => void;
  isDisabled?: boolean;
};

export const TenantTypeRadio = (props: TenantTypeRadioProps) => {
  const { onChange, isDisabled } = props;
  const { control } = useFormContext();

  return (
    <Row>
      <Form.Item label="Tenant Type">
        <Controller
          name="tenantType"
          control={control}
          render={({ field }) => (
            <Radio.Group
              value={field.value}
              disabled={isDisabled}
              onChange={(event: RadioChangeEvent) => {
                field.onChange(event.target.value);
                onChange?.(event.target.value);
              }}
              options={[
                { label: "Company", value: "company" },
                { label: "Individual", value: "individual" },
              ]}
            />
          )}
        />
      </Form.Item>
    </Row>
  );
};
